import { createParamString, slugify } from '@surfline/web-common';

export const liveCamSharePath = ({
  spotName,
  spotId,
  camId,
}: {
  spotName: string;
  spotId: string;
  camId: string;
}) =>
  `/share/surf-report/${slugify(spotName)}/${spotId}/live?${createParamString({
    camId,
  })}`;

export default liveCamSharePath;
